const openUrlInNewTab = (url: string): void => {
  const link = document.createElement("a");
  link.href = url.trim();
  link.target = "_blank";
  link.click();
};

export default openUrlInNewTab;
